<template>
  <div id="childManagement">
    <template v-if="listInquiries">
      <child-inquiries :child="currentChild" @back="hideInquiries" />
    </template>
    <template v-else>
      <v-container class="pa-0">
        <v-layout>
          <v-flex class="xs12 sm12 mb-5">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn fab absolute right class="mr-3 pf-btn-fab" dark v-on="on">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <v-list class="familyOptions">
                <v-list-tile @click="addChildren()">
                  <v-list-tile-content>
                  <v-list-tile-title >
                    Add new child
                  </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="!Agency.is_super_admin ? selectExistingChildren() : {}" :disabled="Agency.is_super_admin">
                  <v-list-tile-content>
                  <v-list-tile-title >
                    Select existing children
                  </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container>
      
      <v-layout wrap row class="mb-4">
        <v-flex sm4 class="pr-2">
          <v-text-field ref="searchField" append-icon="search" @keyup.enter="searchChildren" @click:append="searchChildren" v-model="query.child" label="Search by Child / Case ID" hint="Type atleast 3 characters to search, Case ID should be entered fully"></v-text-field>
        </v-flex>
        <v-flex sm4 class="pr-2">
          <v-select 
            class="filter_left"
            v-model="filterStatus" 
            label="Filter by status"
            :items="[...['All'], ...statusList]" 
            @change="filterByStatus">
            <template v-slot:item="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title>{{ data.item }}</v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
        <!-- <v-flex sm3 class="pr-2">
          <v-select 
            class="filter_left"
            v-model="filterPlacementStatus" 
            label="Filter by Placement Status" 
            :items="[...['All'], ...placementList]"
            @change="filterByPlacementStatus">
             <template v-slot:item="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title v-html="`${data.item} <small>- (Total: ${data.item !== 'All' ? MyChildren.filter(child => child.status.status === data.item).length : MyChildren.length}, Badge: ${ countArr[0] ? countArr[0][data.item] : ''})</small>`"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex> -->
        <v-flex sm4 class="pr-2">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search by Name"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="childList"
          :search="search"
          no-data-text="No results, Search for your children"
          :pagination.sync="pagination" 
          class="pf-data-table"
        >
          <template v-slot:items="props">
            <tr :class="{ 'pf-row-highlighted': Agency.is_super_admin || (props.item.agency && Agency.child.find(x => x.child === props.item.id)) }">
              <td width="150">
                <v-layout justify-left @click="viewChild(props.item)" class="cursor-pointer">
                {{ props.item.name }}
                </v-layout>
              </td>
              <td>
                {{ props.item.type }}
              </td>
              <td>
                <v-layout>
                  {{ formatDateString(props.item.joined_date) }}
                </v-layout>
              </td>
              <td>{{ props.item.agency && props.item.agency.address && props.item.agency.address.length ? (props.item.agency.address[0].state && props.item.agency.address[0].state.name ? props.item.agency.address[0].state.name : '--') : '--' }}</td>
              <td>{{ props.item.other_agencies.filter(x => x.status === 'Enabled').length + 2 }}</td>
              <td>
                <v-layout class="flex-column cursor-pointer">
                  {{ props.item.inquiries ? getSiblingInquiryCount(props.item) : 0 }}
                </v-layout>
              </td>
              <td>
                <v-layout>
                  <v-select
                    v-model="props.item.status.status"
                    :items="statusList"
                    height="30px"
                    :disabled="!Agency.is_super_admin && !Agency.child.find(x => x.child === props.item.id)"
                    @change="saveRequest(props.item, props.index, 'statusChange')"
                  ></v-select>
                </v-layout>
              </td>
              <td class="text-center">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div v-on="cantBeListed(props.item) ? on : ''">
                      <v-switch
                        :disabled="(!Agency.is_super_admin && !Agency.child.find(x => x.child === props.item.id)) || (!props.item.show_on_badge && (!props.item.status.status || props.item.status.status !== 'Active' || !props.item.avatar))"
                        v-model="props.item.show_on_badge"
                        color="#019d8c"
                        :label="props.item.show_on_badge ? 'ON' : 'OFF'"
                        @change="saveRequest(props.item, props.index, 'statusChange')"
                      ></v-switch>
                    </div>
                  </template>
                  <span v-if="cantBeListed(props.item)">{{ cantBeListed(props.item) }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-badge v-if="getInquiryCount(props.item, 'New')" color="red" left overlap size="18">
                  <template v-slot:badge>
                    <span class="pf-font-10">{{ getInquiryCount(props.item, 'New') }}</span>
                  </template>
                  <v-icon class="grey--text" size="22">notifications</v-icon>
                </v-badge>
                <v-icon v-else class="grey--text" size="22">notifications</v-icon>
              </td>
              <td align="right" style="white-space:nowrap;">
                <v-menu offset-y >
                  <template v-slot:activator="{ on }">
                  <v-btn icon small class="mr-0 ml-0" v-on="on">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                    <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                    </template>
                      <span>More</span>
                    </v-tooltip>
                  </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="viewChild(props.item)">
                      <v-list-tile-action>
                        <v-btn icon small class="mr-0 ml-0">
                          <v-icon size="22" color="grey darken-2">visibility</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                       Profile
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="viewDisplayLocations(props.item)">
                      <v-list-tile-action>
                        <v-btn icon small class="mr-0 ml-0">
                          <v-icon size="22" color="grey darken-2">devices</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                       Display Locations
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="showInquiries(props.item)">
                      <v-list-tile-action>
                        <v-btn icon small class="mr-0 ml-0">
                          <v-icon size="22" color="grey darken-2">move_to_inbox</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                       Inquiries
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <!-- <v-list-tile v-if="!session.getSession().adminUser" @click="logonChild(props.item)">
                      <v-list-tile-action>
                        <v-btn icon small class="mr-0 ml-0">
                          <v-icon size="22" color="grey darken-2">call_made</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                       Dashboard
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile> -->
                    <!-- <v-list-tile @click="getHistory(props.item)">
                      <v-list-tile-action>
                        <v-btn icon small class="mr-0 ml-0">
                          <v-icon size="22" color="grey darken-2">history</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                        History
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile> -->
                    <!-- <v-list-tile disabled :href="`${config.host}view-our-families/#/profile/${props.item.id}`" target="_blank">
                      <v-list-tile-action>
                        <v-btn icon class="ma-0">
                            <v-icon size="22" color="grey darken-2">person</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                        Profile
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile> -->
                    <!-- <v-list-tile disabled :target="props.item.nickname ? '_blank' : ''" :href="(props.item.nickname ? config.WPParams.host + 'profile/' + props.item.nickname : 'javascript:void(0)')">
                      <v-list-tile-action>
                        <v-btn icon class="ma-0">
                            <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                        View
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile> -->
                    <v-list-tile @click="deleteChild(props.item, props.index)">
                      <v-list-tile-action>
                        <v-btn icon small class="mr-0 ml-0">
                          <v-icon size="22" class="pf-icon-delete">delete_outline</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                      <v-list-tile-title >
                       Delete
                      </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <template>
        <div class="text-xs-center">
          <v-dialog
            v-model="isHistoryActive"
            width="700"
          >
            <v-card>
              <v-card-title
                class="pf-bg-teal pf-pos-relative headline white--text"
              >
                History &nbsp; <small>-&nbsp; {{ (historyUsername ? historyUsername : 'Unknown') }}</small>
                <v-btn class="pf-icon-top-right" icon dark @click="isHistoryActive = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <app-history :data="historyList"></app-history>
              </v-card-text>
  
              <v-divider></v-divider>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="white"
                  flat
                  @click="isHistoryActive = false"
                  class="pf-bg-pink"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
/* global session config store moment */
import { getCollection, update, create, formatDate, request } from '../../helpers/helpers';
import swal from 'sweetalert2';
import appHistory from '../History/list';
import ChildInquiries from './Inquiries';
export default {
  components: { appHistory, 'child-inquiries': ChildInquiries },
  data: () => ({
    entity: 'ChildManagement',
    waitingPicker: [],
    config: config,
    search: '',
    filterStatus: 'All',
    // filterPlacementStatus: 'All',
    childList: [],
    searchResults: [],
    query: {
      child: ''
    },
    historySearch: '',
    historyUsername: '',
    historyList: [],
    historyHeaders: [
      { text: '#', value: 'id', align: 'left' },
      { text: 'Area', value: 'entity', align: 'left' },
      { text: 'Updated By', value: 'updatedBy' },
      { text: 'Date & Time', value: 'createdAt' }
    ],
    isHistoryActive: false,
    max8chars: v => v.length <= 8 || 'Input too long!',
    statusList: ['Active', 'On Hold', 'Family Matched'],
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Type', value: 'type', align: 'left' },
      { text: 'Join Date', value: 'createdAt', align: 'left' },
      { text: 'Location', value: 'state', align: 'left' },
      { text: 'Display Locations', value: 'display_locations', align: 'left' },
      { text: 'Inquiries', value: 'inquiries', align: 'left' },
      { text: 'Status', value: 'status.status', align: 'left', width: '150px' },
      { text: 'Display', sortable: false, align: 'left' },
      { text: 'Alert', sortable: false, align: 'left' },
      { text: '', sortable: false, align: 'right' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    historyPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    countArr: [],
    listInquiries: false,
    currentChild: null
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    MyChildren: {
      set (value) {
        store.commit('setMyChildren', value);
      },
      get () {
        return store.state.MyChildren;
      }
    },
    ChildrenJSONData: {
      get () {
        return store.state.ChildrenJSONData;
      },
      set (value) {
        store.commit('setChildrenJSONData', value);
      }
    }
  },
  watch: {
    MyChildren (value) {
      this.MyChildren = value;
      this.childList = this.MyChildren;
      this.query.child = '';
    }
  },
  async created () {
    this.initialize(this.$route.query && this.$route.query.requestFrom && this.$route.query.requestFrom === 'update');
    this.initializeAgencyList();
  },

  methods: {
    cantBeListed (item) {
      let text = `Child `;
      if (!this.Agency.is_super_admin && !this.Agency.child.find(x => x.child === item.id)) {
        text += `belongs to another organization`;
        return text;
      }
      if (!item.avatar) {
        text += `doesn't have an avatar`;
      }
      if (item.status.status !== 'Active') {
        text += (!item.avatar ? ' and' : ' is') + ` not active`;
      }
      if (text !== 'Child ') {
        return text;
      }
      return false;
    },
    formatDateString (date) {
      if (!date) return '';
      let dateString = date.substr(0, 10);
      const [year, month, day] = dateString.split('-');
      return `${month}/${day}/${year}`;
    },
    showInquiries (child) {
      if (child && child.child.length) {
        this.currentChild = child;
        this.listInquiries = true;
      }
    },
    hideInquiries () {
      this.currentChild = null;
      this.listInquiries = false;
    },
    getSiblingInquiryCount (child) {
      if (child.type === 'Individual') {
        return child.inquiries ? child.inquiries.length : 0;
      }
      const inquiries = child.inquiries ? child.inquiries.filter(x => x.is_sibling) : [];
      if (inquiries.length) {
        // Define a Set to store unique values
        const uniqueValuesSet = new Set();
        // Iterate through the array and add unique values to the Set
        for (const obj of inquiries) {
          uniqueValuesSet.add(obj.uuid);
        }
        // Get the count of unique values
        const uniqueValuesCount = uniqueValuesSet.size;
        return uniqueValuesCount;
      }
      return 0;
    },
    viewDisplayLocations (item) {
      this.viewChild(item, true, false);
    },
    viewInquiries (item) {
      this.viewChild(item, false, true);
    },
    async changeWaitingSince (e, item) {
      this.waitingPicker = [];
      this.waitingPicker.push(false);
      let itemIndex = this.childList.indexOf(item);
      this.childList[itemIndex].waiting_for = new Date(e).toISOString();
      let updateItem = JSON.parse(JSON.stringify(item));
      updateItem.updated_from = 'default';
      this.unChangedList = JSON.parse(JSON.stringify(this.childList));
      let updateId = this.childList[itemIndex].id;

      /* Update the user ids */
      if (updateItem.human && updateItem.human.length) {
        updateItem.human = updateItem.human.map(x => {
          if (x && x.user && x.user._id) {
            x.user = x.user._id;
          }
          return x;
        });
      }
      
      let { error, data, status } = await update('Child', updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
        });
      } else {
        swal.fire({
          type: 'success',
          title: 'Waiting since saved successfully',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    },
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { /* _id: { $ne: this.Agency.id }, */ is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id,mapping_id,map_sub_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    getAgencyNames (agencyList) {
      if (agencyList.length) {
        let agencyId = agencyList.map(agency => agency.agency);
        let list = this.AgencyList.filter(agency => agencyId.indexOf(agency.id) !== -1);
        if (!this.Agency.is_super_admin) {
          list.push({ name: this.Agency.name });
        }
        let names = list.map(agency => agency.name);
        return names.join(', <br>');
      }
    },
    getInquiryCount (childGroup, status) {
      if (childGroup.inquiries && childGroup.inquiries.length) {
        let readInquiries = childGroup.inquiries.filter(x => !x.is_sibling && x.inquiry_status === status).length;
        if (childGroup.type !== 'Individual') {
          let groupReadInquiries = childGroup.inquiries.filter(x => x.is_sibling && x.inquiry_status === status).length;
          groupReadInquiries = Math.floor(groupReadInquiries / childGroup.child.length);
          readInquiries += groupReadInquiries;
        }
        return readInquiries;
        /* if (isRead) {
          let readInquiries = childGroup.inquiries.filter(x => !x.is_sibling && Boolean(x.is_read)).length;
          if (childGroup.type !== 'Individual') {
            let groupReadInquiries = childGroup.inquiries.filter(x => x.is_sibling && Boolean(x.is_read)).length;
            groupReadInquiries = Math.floor(groupReadInquiries / childGroup.child.length);
            readInquiries += groupReadInquiries;
          }
          return readInquiries;
        } else {
          let unReadInquiries = childGroup.inquiries.filter(x => !x.is_sibling && !x.is_read).length;
          if (childGroup.type !== 'Individual') {
            let groupunReadInquiries = childGroup.inquiries.filter(x => x.is_sibling && !x.is_read).length;
            groupunReadInquiries = Math.floor(groupunReadInquiries / childGroup.child.length);
            unReadInquiries += groupunReadInquiries;
          }
          return unReadInquiries;
        } */
      }
      return 0;
    },
    async initialize (forceFetch = false) {
      if (!this.MyChildren.length || forceFetch) {
        let populate = [{ path: 'child.child', populate: { path: 'human', populate: { path: 'user', select: 'username' }}}, { path: 'agency', select: 'name address', populate: { path: 'address.state', select: 'name' }}];
        let where = {};
        if (['agency', 'caseworker'].indexOf(session.role()) > -1 && !this.Agency.is_super_admin) {
          where['$or'] = [];
          where['$or'].push({ agency: this.Agency.id });
          where['$or'].push({ _id: { $in: this.Agency.other_children.map(x => x.child) }});
        }
        let sort = { 'createdAt': -1 };
        let { error, data } = await getCollection('ChildGroup', true, 0, populate, where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.MyChildren = data;
          }
        }
      }
      this.childList = this.MyChildren;
    },
    /* filterByPlacementStatus () {
      if (this.filterPlacementStatus === 'All') {
        this.childList = this.query.child && this.query.child !== '' ? this.searchResults : this.MyChildren;
      } else if (this.query.child && this.query.child !== '') {
        this.childList = this.searchResults.filter(child => child.status.status === this.filterPlacementStatus);
      } else {
        this.childList = this.MyChildren.filter(child => child.status.status === this.filterPlacementStatus);
      }
      // filter by the status as well
      if (this.filterStatus !== 'All') {
        this.childList = this.childList.filter(child => child.agency.find(agency => agency.status === this.filterStatus && agency.agency === this.Agency.id));
      }
    }, */
    filterByStatus () {
      if (this.filterStatus === 'All') {
        this.childList = this.query.child && this.query.child !== '' ? this.searchResults : this.MyChildren;
      } else if (this.query.child && this.query.child !== '') {
        this.childList = this.searchResults.filter(child => child.status && child.status.status === this.filterStatus);
      } else {
        this.childList = this.MyChildren.filter(child => child.status && child.status.status === this.filterStatus);
      }
    },
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    },
    // @vuese
    // Used to update the family status
    // @arg The account object to be updated
    async statusUpdate (item, mode) {
      let updateItem = JSON.parse(JSON.stringify(item));
      if (mode === 'nickname') {
        updateItem.updated_from = 'nickName';
      } else if (mode === 'joinDate') {
        updateItem.updated_from = 'childInfo';
      } else {
        updateItem.updated_from = 'default';
      }
      this.unChangedList = JSON.parse(JSON.stringify(this.childList));
      let itemIndex = this.childList.indexOf(item);
      let updateId = this.childList[itemIndex].id;
      updateItem.human[0].user = updateItem.human[0].user.id;
      if (updateItem.human.length === 2 && updateItem.human[1].user) {
        updateItem.human[1].user = updateItem.human[1].user.id;
      }
      let { error, data, status } = await update('Child', updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {}
        });
      } else {
        if (mode === 'status') {
          // Create the timeline
          let timelineData = {
            title: 'Profile Status Changed',
            text: `The child profile status was changed to '${item.profile_status}'`,
            child: item.id
          };
          let { error, data, status } = await create('Timeline', timelineData);
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Failed to create the timeline'
            };
          } else {
            swal.fire({
              type: 'success',
              title: 'Details saved successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
              }
            });
          }
        } else {
          let text = '';
          if (mode === 'nickname') {
            text = 'NickName changed successfully';
          } else if (mode === 'joinDate') {
            text = 'Child Details updated successfully';
          } else {
            text = 'Details saved successfully';
          }
          swal.fire({
            type: 'success',
            title: text,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
            }
          });
        }
      }
    },
    // @vuese
    // Used to search for families on entering nickname, PPN or the status
    // @arg The type of search - child or status
    async searchChildren () {
      this.childList = [];
      if (this.query.child === '' && this.query.child.length === 0) {
        this.childList = this.MyChildren;
        // Reset the status filter
        this.filterStatus = 'All';
        // this.filterPlacementStatus = 'All';
        return;
      }
      if ((this.query.child && this.query.child.length && this.query.child.length > 2)) {
        // let where = { 'agency.agency': this.Agency.id, 'agency.status': { '$nin': ['Rejected'] }};
        let where = {};
        if (this.query.child && this.query.child.length > 2) {
          where.$or = [{
            'nickname': { $regex: `.*` + this.query.child + `.*`, $options: 'i' }
          },
          {
            $expr: {
              $eq: [this.query.child, {
                $concat: [
                  'PFCH',
                  {
                    '$toString': '$profile_year'
                  }, {
                    '$toString': '$profile_number'
                  }
                ]
              }]
            }
          },
          {
            'name': { $regex: `.*` + this.query.child + `.*`, $options: 'i' }
          }];
        }
        let populate = [{ path: 'child.child', populate: { path: 'human', populate: { path: 'user', select: 'username' }}}];
        let sort = { 'createdAt': -1 };
        let { error, data } = await getCollection('ChildGroup', true, 0, populate, where, null, null, sort);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to search children'
          };
        } else {
          // Reset the status filter
          this.filterStatus = 'All';
          if (data.length > 0) {
            this.childList = data;
            this.searchResults = data;
          }
        }
      }
    },
    changeDisplay (item) {
      if (item.show_on_badge && (!item.avatar || item.status.status !== 'Active')) {
        // this.childList[index].show_on_badge = item.show_on_badge = false;
        swal.fire({
          type: 'warning',
          text: 'The child should be active, having avatar before displaying on the badge.',
          timer: 2500
        });
        return false;
      }
    },
    // eslint-disable-next-line
    async saveRequest (item, itemIndex, requestFrom = null) {
      let updateItem = Object.assign({}, item);
      let updateId = item.id;
      updateItem.updated_from = 'basic';
      updateItem.status = {
        status: updateItem.status.status,
        date: new Date()
      };
      if (requestFrom) {
        updateItem.updated_from = requestFrom;
      }
      /* Update the user ids */
      if (updateItem.child && updateItem.child.length) {
        updateItem.child = updateItem.child.map(child => {
          if (child.child._id) {
            child.child = child.child._id;
          }
          return child;
        });
      }
      if (updateItem.agency && updateItem.agency._id) {
        updateItem.agency = updateItem.agency._id;
      }
      let { error, data, status } = await update('ChildGroup', updateItem, updateId);
      if (error) {
        console.log('error', error);
      } else {
        // this[entity] = data;
        swal.fire({
          type: 'success',
          title: 'Details saved successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
          }
        });
      }
    },
    async deleteChild (item, listIndex) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            if (this.Agency.is_super_admin || this.Agency.child.find(row => row.child === item.id)) {

              let { error, data } = await request(`ChildGroup/${item.id}?mode=hard`, 'DELETE');
              if (error) {
                console.log('error', error);
              } else {
                const index = this.childList.indexOf(item);
                this.childList.splice(index, 1);
                swal.fire(
                  'Deleted!',
                  'The Child "' + item.name + '" has been deleted.',
                  'success'
                );
              }
            } else {
              const childIndex = this.Agency.other_children.findIndex(row => row.child === item.id);
              if (childIndex > -1) {
                const payload = JSON.parse(JSON.stringify(this.Agency));
                payload.other_children.splice(childIndex, 1);
                payload.updated_from = 'childBadge';
                let { error, data, status } = await update('Agency', payload, payload.id);
                if (error) {
                  console.log('error', error);
                } else {
                  this.Agency.other_children.splice(childIndex, 1);
                  this.MyChildren.splice(listIndex, 1);
                }
              }
            }
          })();
        }
      });
    },
    viewChild (child, showDisplayLocations = false, showInquiries = false) {
      if (child) {
        this.$router.push({ path: `/children/${child._id}`, query: { showDisplayLocations, showInquiries }});
      }
    },
    async logonChild (item) {
      swal.fire({
        type: 'warning',
        title: '<b>Working on it</b>',
        html: 'This page will be available soon',
        showConfirmButton: false,
        timer: 2500,
        onClose: () => {
          // 
        }
      });
      return;
      // if (item.child.length && item.child[0].child.human.length && item.child[0].child.human[0].user) {
      //   let sessionData;
      //   let { error, data } = await getOne('User', item.child[0].child.human[0].user.id);
      //   if (error) {
      //     console.log('error', error);
      //     this.snackbar = {
      //       show: true,
      //       color: 'red',
      //       text: 'Something went wrong, please try again.'
      //     };
      //   } else {
      //     delete data.access;
      //     sessionData = { ...session.getSession() };
      //     sessionData.adminUser = session.getSession().user;
      //     sessionData.user = data;
      //     session.setSession(sessionData, false);
      //     window.location = config.client;
      //   }
      // }
    },
    async getHistory (child) {
      let humanIds = Array.from(child.human, x => x.id);
      let sort = { 'createdAt': -1 };
      let where = { '$or': [{ 'entity': 'Child', 'document_id': child.id }, { 'entity': 'Human', 'document_id': { '$in': humanIds }}], 'updatedBy': { '$exists': true }};
      let populate = { path: 'updatedBy', select: 'entity updatedBy createdAt', populate: { path: 'human', select: 'first_name last_name' }};
      
      if (child.human && child.human.length) {
        where['$or'].push({ 'entity': 'User', 'document_id': child.human[0].user.id });
      }
      let { error, data } = await getCollection('History', true, 10, populate, where, null, null, sort);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        this.historyList = data;
        this.isHistoryActive = true;
        this.historyUsername = child.human[0].first_name + ' ' + child.human[0].last_name;
      }
    },
    async addChildren () {
      this.$router.push({ path: `/children/add` });
    },
    async selectExistingChildren () {
      this.$router.push({ path: `/children/existing` });
    }
  }
};
</script>
<style scoped>
.text-right {
  text-align: right !important;
}

#childManagement >>> .v-select__selection {
    width: 100%;
    justify-content: center;
    padding-left: 10px;
}

#childManagement >>> .filter_left .v-select__selection {
  justify-content: start !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/Children/list.vue